import { ChakraProvider, ColorModeScript, CSSReset } from "@chakra-ui/react";
import * as React from "react";
// import { Helmet } from "react-helmet";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./libs/react-query";
import Plugins from "./plugins";
import Routes from "./routes";
import { theme } from "./theme";

import "react-widgets/styles.css";
import "./style.css";

export default function App() {
  return (
    <>
      {/* <Helmet>
        <meta httpEquiv="Content-Security-Policy" content="default-src 'self' https://*.googleapis.com https://*.gstatic.com https://*.google.com data: blob: 'unsafe-inline' 'unsafe-eval';" />
        <meta httpEquiv="Permissions-Policy" content="geolocation=(self), microphone=()" />
      </Helmet> */}
      <CSSReset />
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <QueryClientProvider client={queryClient}>
          <Plugins>
            <Routes />
          </Plugins>
        </QueryClientProvider>
      </ChakraProvider>
    </>
  );
}
